// The native shell appends `applicationNameForUserAgent` to the WebView's User-Agent, so the
// version is readable synchronously on first render. Builds predating that change carry no
// marker at all, which is the signal itself: unknown means unsupported.
// Anchored to a word start so a longer product token ending in the same name cannot pass as ours.
const NativeAppMarker = /(?:^|\s)FoodAmigosOMS\/(\d+(?:\.\d+){0,2})/;

const VersionPattern = /^\d+(?:\.\d+)*$/;

function parseParts(version) {
  return typeof version === 'string' && VersionPattern.test(version) ? version.split('.').map(Number) : null;
}

// True on every native build, old or new — RN injects the global regardless of version. This is
// the only thing that tells an outdated shell apart from a plain browser.
export function isNativeShell() {
  return Boolean(globalThis.ReactNativeWebView);
}

export function nativeAppVersion(userAgent = globalThis.navigator?.userAgent ?? '') {
  return NativeAppMarker.exec(userAgent)?.[1] ?? null;
}

export function isAtLeastVersion(version, minimum) {
  const parts = parseParts(version);
  const required = parseParts(minimum);

  if (!parts || !required) {
    return false;
  }

  for (let index = 0; index < Math.max(parts.length, required.length); index++) {
    const part = parts[index] ?? 0;
    const requiredPart = required[index] ?? 0;

    if (part !== requiredPart) {
      return part > requiredPart;
    }
  }

  return true;
}
